export type ToastType = 'success' | 'danger' | 'gray';

export interface Toast {
  type: ToastType;
  icon?: string;
  delay: number | boolean;
  message: string;
  params?: Record<string, string>;
}
